import axios from "axios";

import { participantInstance } from ".";
import store from "../../store";
import { setToken } from "../../slice/participantLoginSlice";

const url = process.env.REACT_APP_BASE_URL || "/";

const OnRequest = async (config) => {
  
  if(localStorage.getItem("isError")){
    localStorage.removeItem("isError")
  }
  const token = localStorage.getItem("participant_token") || {};
  if (token && config.headers) {
    config.headers.Authorization = "Bearer " + token;
  }

  return config;
};

const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = async (error) => {
  const originalConfig = error.config;
  if (error.response?.status === 401) {
    const rootState = store.getState();
    const refresh = rootState?.ParticipantLoginReducer?.loginData?.refresh_token || {};
    const { status } = error.response;
    if (status === 401 && !originalConfig._retry) {
      // store. dispatch(logoutRequest({}));
      originalConfig._retry = true;

      try {
        const request = {
          refresh_token: refresh,
        };
        const URL = url + "/participants/refresh-token";
        let responseData = await axios.post(URL, request, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (responseData?.data?.access_token) {
          const { access_token } = responseData?.data;
          originalConfig.headers.Authorization = access_token;
          store.dispatch(setToken(responseData?.data));
          localStorage.setItem("participant_token",responseData?.data?.access_token)
          return participantInstance(originalConfig);
        }

        localStorage.clear();
        window.location.replace("/participants/login");
      } catch (err) {
        localStorage.clear();
        window.location.replace("/participants/login");
      }
    }
  } else {
    return Promise.reject(error);
  }
};

export function setupParticipantInterceptorsTo(axiosInstance) {
  axiosInstance.interceptors.request.use(OnRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
